
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import { UNIT_TYPES, UnitOptions, UnitType } from "@/types/unit";
import defensiveCopy from "@/util/defensive-copy";

import { ElementStudioContext } from "./ElementStudioTabsAndPanels.vue";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";

@Component({
  components: {
    Repeater,
    DropdownInput
  }
})
export default class ElementStudioUnitOptions extends Vue {
  @Prop()
  value!: UnitOptions | null;

  get internalValue() {
    return this.value || {};
  }

  @Inject("context") readonly context!: ElementStudioContext;

  get availableTypes() {
    return UNIT_TYPES;
  }

  control = {
    options: {
      repeaterOptions: {
        titleTemplate: "Type",
        buttonName: "Add type"
      }
    }
  };

  updateTypes(types: UnitType[]) {
    const newOptions = defensiveCopy(this.internalValue);

    this.emit({
      ...newOptions,
      types
    });
  }

  updateDefaultType(defaultType: UnitType) {
    const newOptions = defensiveCopy(this.internalValue);

    this.emit({
      ...newOptions,
      defaultType
    });
  }

  updateDisableCustomUnitDropdown(disableCustomUnitDropdown: boolean) {
    const newOptions = defensiveCopy(this.internalValue);

    this.emit({
      ...newOptions,
      disableCustomUnitDropdown
    });
  }

  emit(unitOptions: UnitOptions) {
    this.$emit("input", unitOptions);
  }
}
